import { useFetchActivePurchasedDataSourceByListingIdQuery } from "@biggeo/bg-server-lib/studio";
import { isSuccess } from "@vividtheory/remotedata";
import { MapContextDataset } from "../../map/mapbox/context/types";
import { DataSampleCard } from "@biggeo/bg-ui/lab";

export interface IDataSampleCardContainer {
    sample: MapContextDataset;
    onBuyNowClick: (fkMarketplaceDatasetId: string) => void;
    onContactSalesClick: (fkMarketplaceDatasetId: string) => void;
    onDeleteClick?: () => void;
    onSwitchClick: (i: {
        dataSourceId: string;
        isSelected: boolean;
    }) => void;
}

const DataSampleCardContainer = ({
    sample,
    onBuyNowClick,
    onContactSalesClick,
    ...props
}: IDataSampleCardContainer) => {
    const { remote: activePurchaseRd } =
        useFetchActivePurchasedDataSourceByListingIdQuery(
            sample.fkMarketplaceDatasetId
                ? {
                      variables: {
                          input: {
                              fkMarketplaceDatasetId:
                                  sample.fkMarketplaceDatasetId,
                          },
                      },
                  }
                : { skip: true }
        );

    return (
        <DataSampleCard
            {...props}
            status={sample.dataSourceConfiguration.status}
            targetState={sample.dataSourceConfiguration.targetState}
            onBuyNowClick={() => {
                if (sample.fkMarketplaceDatasetId) {
                    onBuyNowClick(sample.fkMarketplaceDatasetId);
                }
            }}
            onContactSalesClick={() => {
                if (sample.fkMarketplaceDatasetId) {
                    onContactSalesClick(sample.fkMarketplaceDatasetId);
                }
            }}
            color={sample.color}
            image={sample.image}
            name={sample.dataSource.name}
            organization={sample.organization}
            isSelected={sample.isSelected}
            fkDataSourceId={sample.dataSource.id}
            isBuyNowDisabled={
                !isSuccess(activePurchaseRd) ||
                !!activePurchaseRd.data
                    ?.fetchActivePurchasedDataSourceByListingId
            }
        />
    );
};

export default DataSampleCardContainer;
